import { getFrontendConfigLoader } from '@doxyme/config';

export const isProduction = (): boolean =>
  (getFrontendConfigLoader().get('ENV') as string) === 'production';
